const Component = () => {

  window.location.href = `${process.env.REACT_APP_MCA_URL}`;
};

export default Component;
